export default __webpack_public_path__ + "static/media/homeDredge4sq.e01b8228.jpg";